/* Importations Bibliothèques React-router-dom  */
import React from "react";
import { NavLink } from "react-router-dom";

import Theiere from "../../images/TableauxVendu/1995/Theiere.webp";
import FraisesEtPlatEnEtain from "../../images/TableauxVendu/1995/Fraises-Et-Plat-En-Etain.webp";
import CoupeAbricots from "../../images/TableauxVendu/1995/Coupe-Abricots.webp";
import PainEtOeufCoque from "../../images/TableauxVendu/1996/Pain-Et-Oeuf-Coque.webp";
import ConfitureDes4FruitsRouges from "../../images/TableauxVendu/1996/Confiture-Des-4-Fruits-Rouges.webp";
import PainVinEtLaguiole from "../../images/TableauxVendu/1996/Pain-Vin-Et-Laguiole.webp";
import CarafeEtPetitsGateaux from "../../images/TableauxVendu/1996/Carafe-Et-Petits-Gateaux.webp";
import VaseLaqueEtPivoines from "../../images/TableauxVendu/1996/Vase-Laque-Et-Pivoines.webp";
import BriocheEtChampagne from "../../images/TableauxVendu/1997/Brioche-Et-Champagne.webp";
import BriocheEtPotALait from "../../images/TableauxVendu/1997/Brioche-Et-Pot-A-Lait.webp";
import ChopeEnEtainEtOlives from "../../images/TableauxVendu/1997/Chope-En-Etain-Et-Olives.webp";
import ConfitureDabricot from "../../images/TableauxVendu/1997/Confiture-Abricot.webp";
import CorbeilleAbricots from "../../images/TableauxVendu/1997/Corbeille-Abricots.webp";
import CrucheEngres from "../../images/TableauxVendu/1997/Cruche-Engres.webp";
import GrandPere from "../../images/TableauxVendu/1997/Grand-Pere.webp";
import JambonEtPain from "../../images/TableauxVendu/1997/Jambon-Et-Pain.webp";
import LePainEtLeVin from "../../images/TableauxVendu/1997/Le-Pain-Et-Le-Vin.webp";
import PainCuivreEtCouteau from "../../images/TableauxVendu/1997/Pain-Cuivre-Et-Couteau.webp";
import PainCuivreEtOeufs from "../../images/TableauxVendu/1997/Pain-Cuivre-Et-Oeufs.webp";
import PanierDeFruits from "../../images/TableauxVendu/1997/Panier-De-Fruits.webp";
import PauseCafe from "../../images/TableauxVendu/1997/Pause-Cafe.webp";
import Peches from "../../images/TableauxVendu/1997/Peches.webp";
import PommesEtPotEnLaiton from "../../images/TableauxVendu/1997/Pommes-Et-Pot-En-Laiton.webp";
import PotPourrisEtDentelle from "../../images/TableauxVendu/1997/Pot-Pourris-Et-Dentelle.webp";
import Provence from "../../images/TableauxVendu/1997/Provence.webp";
import SourceDeVie from "../../images/TableauxVendu/1997/Source-De-Vie.webp";
import CarafeEtRaisins from "../../images/TableauxVendu/1998/Carafe-Et-Raisins.webp";
import Cerises from "../../images/TableauxVendu/1998/Cerises.webp";
import Chardons from "../../images/TableauxVendu/1998/Chardons.webp";
import JeuxDhier from "../../images/TableauxVendu/1998/Jeux-Dhier.webp";
import LesOeufs from "../../images/TableauxVendu/1998/Les-Oeufs.webp";
import LheureDuThe from "../../images/TableauxVendu/1998/Lheure-Du-The.webp";
import OeufCoqueEtPoussin from "../../images/TableauxVendu/1998/Oeuf-Coque-Et-Poussin.webp";
import Calligraphie from "../../images/TableauxVendu/1999/Calligraphie.webp";
import CerisesEtWhisky from "../../images/TableauxVendu/1999/Cerises-Et-Whisky.webp";
import Degustation from "../../images/TableauxVendu/1999/Degustation.webp";
import FleursDeLys from "../../images/TableauxVendu/1999/Fleurs-De-Lys.webp";
import LePetitBouchon from "../../images/TableauxVendu/1999/Le-Petit-Bouchon.webp";
import LeRomanDesDeuxRoses from "../../images/TableauxVendu/1999/Le-Roman-Des-Deux-Roses.webp";
import LesCerises from "../../images/TableauxVendu/1999/Les-Cerises.webp";
import LesFraises from "../../images/TableauxVendu/1999/Les-Fraises.webp";
import Nocturne from "../../images/TableauxVendu/1999/Nocturne.webp";
import PageDecriture from "../../images/TableauxVendu/1999/Page-Decriture.webp";
import PommeEtNoix from "../../images/TableauxVendu/1999/Pomme-Et-Noix.webp";
import VaseBleu from "../../images/TableauxVendu/1999/Vase-Bleu.webp";
import AutomneII from "../../images/TableauxVendu/2000/Automne-II.webp";
import Automne1 from "../../images/TableauxVendu/2000/Automne1.webp";
import AutourDuVinII from "../../images/TableauxVendu/2000/Autour-Du-Vin-II.webp";
import AutourDuVin from "../../images/TableauxVendu/2000/Autour-Du-Vin.webp";
import Cognac from "../../images/TableauxVendu/2000/Cognac.webp";
import Correspondance from "../../images/TableauxVendu/2000/Correspondance.webp";
import CuivreEtPainII from "../../images/TableauxVendu/2000/Cuivre-Et-Pain-II.webp";
import LeGouter from "../../images/TableauxVendu/2000/Le-Gouter.webp";
import LeVerreDeVin from "../../images/TableauxVendu/2000/Le-Verre-De-Vin.webp";
import Liqueur from "../../images/TableauxVendu/2000/Liqueur.webp";
import LartDuVin from "../../images/TableauxVendu/2000/Lart-Du-Vin.webp";
import PainEtPichet from "../../images/TableauxVendu/2000/Pain-Et-Pichet.webp";
import LeCidre from "../../images/TableauxVendu/2000/Le-Cidre.webp";
import PetitDejeuner from "../../images/TableauxVendu/2000/Petit-Dejeuner.webp";
import TireBouchon from "../../images/TableauxVendu/2000/Tire-Bouchon.webp";
import CadreReflets from "../../images/TableauxVendu/2001/Cadre-Reflets.webp";
import Fraicheur from "../../images/TableauxVendu/2001/Fraicheur.webp";
import LoiseauDeCristal from "../../images/TableauxVendu/2001/Loiseau-De-Cristal.webp";
import Londres1924 from "../../images/TableauxVendu/2001/Londres-1924.webp";
import MatinBonheur from "../../images/TableauxVendu/2001/Matin-Bonheur.webp";
import PetitesBoites from "../../images/TableauxVendu/2001/Petites-Boites.webp";
import Quietude from "../../images/TableauxVendu/2001/Quietude.webp";
import TimbaleAuxCerises from "../../images/TableauxVendu/2001/Timbale-Aux-Cerises.webp";
import TimbaleAuxFraises from "../../images/TableauxVendu/2001/Timbale-Aux-Fraises.webp";
import TimbaleAuxFramboises from "../../images/TableauxVendu/2001/Timbale-Aux-Framboises.webp";
import CuivreVaseBleu from "../../images/TableauxVendu/2002/Cuivre-Vase-Bleu.webp";
import Dentiste from "../../images/TableauxVendu/2002/Dentiste.webp";
import Exotique from "../../images/TableauxVendu/2002/Exotique.webp";
import LeConfiturier from "../../images/TableauxVendu/2002/Le-Confiturier.webp";
import PasseTemps from "../../images/TableauxVendu/2002/Passe-Temps.webp";
import Senteur from "../../images/TableauxVendu/2002/Senteur.webp";
import TelsQuilsFurent from "../../images/TableauxVendu/2002/Tels-Quils-Furent.webp";
import TimbaleALaPipe from "../../images/TableauxVendu/2002/Timbale-A-La-Pipe.webp";
import Vendange from "../../images/TableauxVendu/2002/Vendange.webp";
import AlpageLepage from "../../images/TableauxVendu/2003/Alpage-Lepage.webp";
import CoupeDeRaisin from "../../images/TableauxVendu/2003/Coupe-De-Raisin.webp";
import Douceurs from "../../images/TableauxVendu/2003/Douceurs.webp";
import Ensavoie from "../../images/TableauxVendu/2003/En-savoie.webp";
import FruitsDete from "../../images/TableauxVendu/2003/Fruits-Dete.webp";
import Lecture from "../../images/TableauxVendu/2003/Lecture.webp";
import LesDeuxTomesDesavoie from "../../images/TableauxVendu/2003/Les-Deux-Tomes-De-savoie.webp";
import LesTroisGres from "../../images/TableauxVendu/2003/Les-Trois-Gres.webp";
import ReveilMatin from "../../images/TableauxVendu/2003/Reveil-Matin.webp";
import SouvenirsDeSavoie from "../../images/TableauxVendu/2003/Souvenirs-De-Savoie.webp";
import Souvenirs from "../../images/TableauxVendu/2003/Souvenirs.webp";
import AlcoolEtDentelle from "../../images/TableauxVendu/2004/Alcool-Et-Dentelle.webp";
import Alcools from "../../images/TableauxVendu/2004/Alcools.webp";
import AndrosacesAvecOpinel from "../../images/TableauxVendu/2004/Androsaces-Avec-Opinel.webp";
import CasseCrouteSavoyard from "../../images/TableauxVendu/2004/Casse-Croute-Savoyard.webp";
import CerisesEtFraise from "../../images/TableauxVendu/2004/Cerises-Et-Fraise.webp";
import DegustationEnsavoie from "../../images/TableauxVendu/2004/Degustation-En-savoie.webp";
import EncrierEtTimbale from "../../images/TableauxVendu/2004/Encrier-Et-Timbale.webp";
import FleurDeternite from "../../images/TableauxVendu/2004/Fleur-Deternite.webp";
import FleurEtFramboises from "../../images/TableauxVendu/2004/Fleur-Et-Framboises.webp";
import FruitsRouges from "../../images/TableauxVendu/2004/Fruits-Rouges.webp";
import Inspiration from "../../images/TableauxVendu/2004/Inspiration.webp";
import LesPlaisirsDefendus from "../../images/TableauxVendu/2004/Les-Plaisirs-Defendus.webp";
import MignonneAllonsVoirSiLaRose from "../../images/TableauxVendu/2004/Mignonne-Allons-Voir-Si-La-Rose.webp";
import PainEtOeufs from "../../images/TableauxVendu/2004/Pain-Et-oeufs.webp";
import PauseCasseCroute from "../../images/TableauxVendu/2004/Pause-casse-Croute.webp";
import PauseLecture from "../../images/TableauxVendu/2004/Pause-Lecture.webp";
import PommeEtCroissants from "../../images/TableauxVendu/2004/Pomme-Et-Croissants.webp";
import Printemps from "../../images/TableauxVendu/2004/Printemps.webp";
import SagesseDeLorient from "../../images/TableauxVendu/2004/Sagesse-De-Lorient.webp";
import TommeEtCarlines from "../../images/TableauxVendu/2004/Tomme-Et-Carlines.webp";
import UnGrandBol from "../../images/TableauxVendu/2004/Un-Grand-Bol.webp";
import Aladin from "../../images/TableauxVendu/2005/Aladin.webp";
import EncrierI from "../../images/TableauxVendu/2005/Encrier-I.webp";
import EncrierII from "../../images/TableauxVendu/2005/Encrier-II.webp";
import PauseCasseCrouteII from "../../images/TableauxVendu/2005/Pause-Casse-Croute-II.webp";
import PipeEtPichetDoree from "../../images/TableauxVendu/2005/Pipe-Et-Pichet-Doree.webp";
import UnPetitCroissant from "../../images/TableauxVendu/2005/Un-Petit-Croissant.webp";
import UnPichetDore from "../../images/TableauxVendu/2005/Un-Pichet-Dore.webp";
import UnPetitNoir from "../../images/TableauxVendu/2006/Cadre-Un-Ptit-Noir.webp";
import Bonjour from "../../images/TableauxVendu/2006/Bonjour.webp";
import CognacEtDentelle from "../../images/TableauxVendu/2006/Cognac-Et-Dentelle.webp";
import FruitsRougesEtConfiture from "../../images/TableauxVendu/2006/Fruits-Rouges-Et-Confiture.webp";
import LivresEtRose from "../../images/TableauxVendu/2006/Livres-Et-Rose.webp";
import PommeEtChocolat from "../../images/TableauxVendu/2006/Pomme-Et-Chocolat.webp";
import CasseCrouteEnMontagne from "../../images/TableauxVendu/2007/Casse-Croute-En-Montagne.webp";
import CadreLeTempsDesLumieres from "../../images/TableauxVendu/2008/Cadre-Le-Temps-Des-Lumieres.webp";
import ConfitureEtFruits from "../../images/TableauxVendu/2008/Confiture-Et-Fruits.webp";
import Litterature from "../../images/TableauxVendu/2008/Litterature.webp";

function Vendue() {
  return (
    <main>
      <section className="Galerie">
        <h2 className="Titre-Nature-Morte">
          <NavLink to="/MesCreations">
            <i className="fas fa-chevron-circle-right"></i>
            &nbsp; Nature morte / &nbsp;Velours en vente&nbsp;&nbsp;&nbsp;&nbsp;
          </NavLink>
        </h2>
        <h3>Nature-Morte-Galerie Vendu</h3>
        <div className="Galerie1-Nature-Morte-Vente">
          <figure id="Provence">
            <div className="Div-Reserve">
              <a href={Provence}>
                <img
                  src={Provence}
                  alt="Provence"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Reserve-Image">Reservé</span>
            </div>
            <figcaption>
              <h4>Provence</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Dentiste">
            <div className="Div-Reserve">
              <a href={Dentiste}>
                <img
                  src={Dentiste}
                  alt="Dentiste"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Reserve-Image">Reservé</span>
            </div>
            <figcaption>
              <h4>Dentiste</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Souvenirs-De-Savoie">
            <div className="Div-Reserve">
              <a href={SouvenirsDeSavoie}>
                <img
                  src={SouvenirsDeSavoie}
                  alt="Souvenirs de Savoie"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Reserve-Image">Reservé</span>
            </div>
            <figcaption>
              <h4>Souvenirs de Savoie</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Printemps">
            <div className="Div-Reserve">
              <a href={Printemps}>
                <img
                  src={Printemps}
                  alt="Printemps"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Reserve-Image">Reservé</span>
            </div>
            <figcaption>
              <h4>Printemps</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="DegustationEnSavoie">
            <div className="Div-vendue">
              <a href={DegustationEnsavoie}>
                <img
                  src={DegustationEnsavoie}
                  alt="Degustations en Savoie"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Degustations en Savoie</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Le-Cidre">
            <div className="Div-vendue">
              <a href={LeCidre}>
                <img
                  src={LeCidre}
                  alt="Le cidre"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Le cidre</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Passe-Temps">
            <div className="Div-vendue">
              <a href={PasseTemps}>
                <img
                  src={PasseTemps}
                  alt="Passe-temps"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Passe-temps</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Loiseau-De-Cristal">
            <div className="Div-vendue">
              <a href={LoiseauDeCristal}>
                <img
                  src={LoiseauDeCristal}
                  alt="L'oiseau de cristal"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>L'oiseau de cristal</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Pot-Pourris-Et-Dentelle">
            <div className="Div-vendue">
              <a href={PotPourrisEtDentelle}>
                <img
                  src={PotPourrisEtDentelle}
                  alt="Pot pourris et dentelle"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Pot pourris et dentelle</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Theiere">
            <div className="Div-vendue">
              <a href={Theiere}>
                <img
                  src={Theiere}
                  alt="Théière"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Théière</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Fraises-Et-Plat-En-Etain">
            <div className="Div-vendue">
              <a href={FraisesEtPlatEnEtain}>
                <img
                  src={FraisesEtPlatEnEtain}
                  alt="Fraises et plat en étain"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Fraises et plat en étain</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Coupe-Dabricots">
            <div className="Div-vendue">
              <a href={CoupeAbricots}>
                <img
                  src={CoupeAbricots}
                  alt="Coupe d'Abricots"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Coupe d'abricots</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Pain-Et-Oeuf-Coque">
            <div className="Div-vendue">
              <a href={PainEtOeufCoque}>
                <img
                  src={PainEtOeufCoque}
                  alt="Pain et oeuf coque"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Pain et oeuf coque</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Confiture-Des-4-Fuits-Rouges">
            <div className="Div-vendue">
              <a href={ConfitureDes4FruitsRouges}>
                <img
                  src={ConfitureDes4FruitsRouges}
                  alt="Confiture des 4 fruits rouges"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Confiture des 4 fruits rouges</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Pain-Vin-Et-Laguiole">
            <div className="Div-vendue">
              <a href={PainVinEtLaguiole}>
                <img
                  src={PainVinEtLaguiole}
                  alt="Pain vin et laguiole"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Pain-Vin-Et-Laguiole</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Carafe-Et-Petits-Gateaux">
            <div className="Div-vendue">
              <a href={CarafeEtPetitsGateaux}>
                <img
                  src={CarafeEtPetitsGateaux}
                  alt="Carafe et petits gâteaux"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Carafe et petits gâteaux</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Vase-laque-Et-Pivoines">
            <div className="Div-vendue">
              <a href={VaseLaqueEtPivoines}>
                <img
                  src={VaseLaqueEtPivoines}
                  alt="Vase laqué et pivoines"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Vase laqué et pivoines</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Brioche-Et-Pot-A-Lait">
            <div className="Div-vendue">
              <a href={BriocheEtPotALait}>
                <img
                  src={BriocheEtPotALait}
                  alt="Brioche et pot à lait"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Brioche et pot à lait</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Corbeille-Abricots">
            <div className="Div-vendue">
              <a href={CorbeilleAbricots}>
                <img
                  src={CorbeilleAbricots}
                  alt="Corbeille d'abricots"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Corbeille d'abricots</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Chope-En-Etain-Et-Olives">
            <div className="Div-vendue">
              <a href={ChopeEnEtainEtOlives}>
                <img
                  src={ChopeEnEtainEtOlives}
                  alt="Chope en étain et olives"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Chope en étain et olives</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="BriocheEtChampagne">
            <div className="Div-vendue">
              <a href={BriocheEtChampagne}>
                <img
                  src={BriocheEtChampagne}
                  alt="Brioche et champagne"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Brioche et champagne</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="ConfitureDabricot">
            <div className="Div-vendue">
              <a href={ConfitureDabricot}>
                <img
                  src={ConfitureDabricot}
                  alt="Confiture d'abricot"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Confiture d'abricot</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Peches">
            <div className="Div-vendue">
              <a href={Peches}>
                <img src={Peches} alt="Pêches" title="Cliquez pour agrandir" />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Pêches</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Le-Pain-Et-Le-Vin">
            <div className="Div-vendue">
              <a href={LePainEtLeVin}>
                <img
                  src={LePainEtLeVin}
                  alt="Le pain et le vin"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Le pain et le vin</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Pain-Cuivre-et-oeufs">
            <div className="Div-vendue">
              <a href={PainCuivreEtOeufs}>
                <img
                  src={PainCuivreEtOeufs}
                  alt="Pain Cuivre et oeufs"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Pain Cuivre et oeufs</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Pommes-et-pot-en-laiton">
            <div className="Div-vendue">
              <a href={PommesEtPotEnLaiton}>
                <img
                  src={PommesEtPotEnLaiton}
                  alt="Pommes et pot en laiton"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Pommes et pot en laiton</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Jambon et pain">
            <div className="Div-vendue">
              <a href={JambonEtPain}>
                <img
                  src={JambonEtPain}
                  alt="Jambon et pain"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Jambon et pain</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Panier-de-fruits">
            <div className="Div-vendue">
              <a href={PanierDeFruits}>
                <img
                  src={PanierDeFruits}
                  alt="Panier de fruits"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Panier de fruits</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Pause-Cafe">
            <div className="Div-vendue">
              <a href={PauseCafe}>
                <img
                  src={PauseCafe}
                  alt="Pause café"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Pause café</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Grand-Pere">
            <div className="Div-vendue">
              <a href={GrandPere}>
                <img
                  src={GrandPere}
                  alt="Grand père"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Grand-père</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Source-De-Vie">
            <div className="Div-vendue">
              <a href={SourceDeVie}>
                <img
                  src={SourceDeVie}
                  alt="Source de vie"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Source de vie</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Cruche-En-gres">
            <div className="Div-vendue">
              <a href={CrucheEngres}>
                <img
                  src={CrucheEngres}
                  alt="Cruche engrès"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Cruche en grès</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Pain-Cuivre-Et-Couteau">
            <div className="Div-vendue">
              <a href={PainCuivreEtCouteau}>
                <img
                  src={PainCuivreEtCouteau}
                  alt="Pain cuivre et couteau"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Pain cuivre et couteau</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Jeux-Dhier">
            <div className="Div-vendue">
              <a href={JeuxDhier}>
                <img
                  src={JeuxDhier}
                  alt="Jeux d'hier"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Jeux d'hier</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Oeuf-Coque-Et-Poussin">
            <div className="Div-vendue">
              <a href={OeufCoqueEtPoussin}>
                <img
                  src={OeufCoqueEtPoussin}
                  alt="Oeuf coque et poussin"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Oeuf coque et poussin</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Lheure-Du-The">
            <div className="Div-vendue">
              <a href={LheureDuThe}>
                <img
                  src={LheureDuThe}
                  alt="L'heure du Thé"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>L'heure du thé</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Chardons">
            <div className="Div-vendue">
              <a href={Chardons}>
                <img
                  src={Chardons}
                  alt="Chardons"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Chardons</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Carafe-Et-Raisins">
            <div className="Div-vendue">
              <a href={CarafeEtRaisins}>
                <img
                  src={CarafeEtRaisins}
                  alt="Carafe et raisins"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Carafe et raisins</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Cerises">
            <div className="Div-vendue">
              <a href={Cerises}>
                <img
                  src={Cerises}
                  alt="Cerises"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Cerises</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Les-Oeufs">
            <div className="Div-vendue">
              <a href={LesOeufs}>
                <img
                  src={LesOeufs}
                  alt="Les oeufs"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Les oeufs</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Degustation">
            <div className="Div-vendue">
              <a href={Degustation}>
                <img
                  src={Degustation}
                  alt="Dégustation"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Dégustation</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Page-Decriture">
            <div className="Div-vendue">
              <a href={PageDecriture}>
                <img
                  src={PageDecriture}
                  alt="Page d'écriture"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Page d'écriture</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Vase-Bleu">
            <div className="Div-vendue">
              <a href={VaseBleu}>
                <img
                  src={VaseBleu}
                  alt="Vase Bleu"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Vase Bleu</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Calligraphie">
            <div className="Div-vendue">
              <a href={Calligraphie}>
                <img
                  src={Calligraphie}
                  alt="Calligraphie"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Calligraphie</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Le-Roman-Des-Deux-Roses">
            <div className="Div-vendue">
              <a href={LeRomanDesDeuxRoses}>
                <img
                  src={LeRomanDesDeuxRoses}
                  alt="Le Roman des deux roses"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Le roman des deux roses</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Les-Fraises">
            <div className="Div-vendue">
              <a href={LesFraises}>
                <img
                  src={LesFraises}
                  alt="Les fraises"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Les fraises</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Les-Cerises">
            <div className="Div-vendue">
              <a href={LesCerises}>
                <img
                  src={LesCerises}
                  alt="Les cerises"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Les cerises</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Cerises-Et-Whisky">
            <div className="Div-vendue">
              <a href={CerisesEtWhisky}>
                <img
                  src={CerisesEtWhisky}
                  alt="Cerises et whisky"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Cerises et whisky</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Nocturne">
            <div className="Div-vendue">
              <a href={Nocturne}>
                <img
                  src={Nocturne}
                  alt="Nocturne"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Nocturne</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Le-Petit-Bouchon">
            <div className="Div-vendue">
              <a href={LePetitBouchon}>
                <img
                  src={LePetitBouchon}
                  alt="Le petit bouchon"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Le petit bouchon</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Pomme-Et-Noix">
            <div className="Div-vendue">
              <a href={PommeEtNoix}>
                <img
                  src={PommeEtNoix}
                  alt="Pomme et noix"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Pomme et noix</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Fleurs-De-Lys">
            <div className="Div-vendue">
              <a href={FleursDeLys}>
                <img
                  src={FleursDeLys}
                  alt="Fleurs de lys"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Fleurs de lys</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Autour-Du-Vin">
            <div className="Div-vendue">
              <a href={AutourDuVin}>
                <img
                  src={AutourDuVin}
                  alt="Autour du vin"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Autour du vin</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Correspondance">
            <div className="Div-vendue">
              <a href={Correspondance}>
                <img
                  src={Correspondance}
                  alt="Correspondance"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Correspondance</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Liqueur">
            <div className="Div-vendue">
              <a href={Liqueur}>
                <img
                  src={Liqueur}
                  alt="Liqueur"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Liqueur</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Autour-Du-Vin-II">
            <div className="Div-vendue">
              <a href={AutourDuVinII}>
                <img
                  src={AutourDuVinII}
                  alt="Autour du vin II"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Autour du vin II</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Le-Verre-De-Vin">
            <div className="Div-vendue">
              <a href={LeVerreDeVin}>
                <img
                  src={LeVerreDeVin}
                  alt="Le verre de vin"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Le verre de vin </h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Tire-Bouchon">
            <div className="Div-vendue">
              <a href={TireBouchon}>
                <img
                  src={TireBouchon}
                  alt="Tire-bouchon"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Tire-Bouchon</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Lart-Du-Vin">
            <div className="Div-vendue">
              <a href={LartDuVin}>
                <img
                  src={LartDuVin}
                  alt="L'art du vin"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>L'art du vin</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Le-Gouter">
            <div className="Div-vendue">
              <a href={LeGouter}>
                <img
                  src={LeGouter}
                  alt="Le Goûter"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Le goûter</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Cognac">
            <div className="Div-vendue">
              <a href={Cognac}>
                <img src={Cognac} alt="Cognac" title="Cliquez pour agrandir" />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Cognac</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Petit-Dejeuner">
            <div className="Div-vendue">
              <a href={PetitDejeuner}>
                <img
                  src={PetitDejeuner}
                  alt="Petit déjeuner"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Petit déjeuner</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Cuivre-Et-Pain-II">
            <div className="Div-vendue">
              <a href={CuivreEtPainII}>
                <img
                  src={CuivreEtPainII}
                  alt="Cuivre et pain II"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Cuivre et pain II</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Automne1">
            <div className="Div-vendue">
              <a href={Automne1}>
                <img
                  src={Automne1}
                  alt="Automne1"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Automne1</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Automne-II">
            <div className="Div-vendue">
              <a href={AutomneII}>
                <img
                  src={AutomneII}
                  alt="Automne-II"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Automne-II</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Pain-Et-Pichet">
            <div className="Div-vendue">
              <a href={PainEtPichet}>
                <img
                  src={PainEtPichet}
                  alt="Pain et pichet"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Pain et pichet</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Matin-Bonheur">
            <div className="Div-vendue">
              <a href={MatinBonheur}>
                <img
                  src={MatinBonheur}
                  alt="Matin bonheur"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Matin et bonheur</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Quietude">
            <div className="Div-vendue">
              <a href={Quietude}>
                <img
                  src={Quietude}
                  alt="Quiètude"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Quiètude</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Reflets">
            <div className="Div-vendue">
              <a href={CadreReflets}>
                <img
                  src={CadreReflets}
                  alt="Reflets"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Reflets</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Fraicheur">
            <div className="Div-vendue">
              <a href={Fraicheur}>
                <img
                  src={Fraicheur}
                  alt="Fraicheur"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Fraicheur</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Tinbale-Aux-Fraises">
            <div className="Div-vendue">
              <a href={TimbaleAuxFraises}>
                <img
                  src={TimbaleAuxFraises}
                  alt="Timbale aux fraises"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Tinbale aux fraises</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Timbale-Aux-Cerises">
            <div className="Div-vendue">
              <a href={TimbaleAuxCerises}>
                <img
                  src={TimbaleAuxCerises}
                  alt="Tinbale aux cerises"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Timbale aux cerises</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Timbale-Aux-Framboises">
            <div className="Div-vendue">
              <a href={TimbaleAuxFramboises}>
                <img
                  src={TimbaleAuxFramboises}
                  alt="Timbale aux framboises"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Timbale aux framboises</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Petite-Boites">
            <div className="Div-vendue">
              <a href={PetitesBoites}>
                <img
                  src={PetitesBoites}
                  alt="Petite boîtes"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Petite boîtes</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Londres-1924">
            <div className="Div-vendue">
              <a href={Londres1924}>
                <img
                  src={Londres1924}
                  alt="Londres 1924"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Londres 1924</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Senteur">
            <div className="Div-vendue">
              <a href={Senteur}>
                <img
                  src={Senteur}
                  alt="Senteur"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Senteur</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Exotique">
            <div className="Div-vendue">
              <a href={Exotique}>
                <img
                  src={Exotique}
                  alt="Exotique"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Exotique</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Tel-Quils-Furent">
            <div className="Div-vendue">
              <a href={TelsQuilsFurent}>
                <img
                  src={TelsQuilsFurent}
                  alt="Tel qu'ils furent"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Tels qu'ils furent</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="TimbaleAlaPipe">
            <div className="Div-vendue">
              <a href={TimbaleALaPipe}>
                <img
                  src={TimbaleALaPipe}
                  alt="Timbale à la pipe"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Timbale à la pipe</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Vendange">
            <div className="Div-vendue">
              <a href={Vendange}>
                <img
                  src={Vendange}
                  alt="Vendange"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Vendange</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="LeConfiturier">
            <div className="Div-vendue">
              <a href={LeConfiturier}>
                <img
                  src={LeConfiturier}
                  alt="Le confiturier"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Le confiturier</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Cuivre-Vase-Bleu">
            <div className="Div-vendue">
              <a href={CuivreVaseBleu}>
                <img
                  src={CuivreVaseBleu}
                  alt="Cuivre et vase bleu"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Cuivre vase bleu</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Souvenirs">
            <div className="Div-vendue">
              <a href={Souvenirs}>
                <img
                  src={Souvenirs}
                  alt="Souvenirs"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Souvenirs</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Reveil-Matin">
            <div className="Div-vendue">
              <a href={ReveilMatin}>
                <img
                  src={ReveilMatin}
                  alt="Reveil-Matin"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Reveil-Matin</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Douceurs">
            <div className="Div-vendue">
              <a href={Douceurs}>
                <img
                  src={Douceurs}
                  alt="Douceurs"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Douceurs</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Lecture">
            <div className="Div-vendue">
              <a href={Lecture}>
                <img
                  src={Lecture}
                  alt="Lecture"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Lecture</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Les-Deux-Tomes-De-Savoie">
            <div className="Div-vendue">
              <a href={LesDeuxTomesDesavoie}>
                <img
                  src={LesDeuxTomesDesavoie}
                  alt="Les deux tomes de savoie"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Les deux tomes de savoie</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Alpage-Lepage">
            <div className="Div-vendue">
              <a href={AlpageLepage}>
                <img
                  src={AlpageLepage}
                  alt="Alpage-Lepage"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Alpage-Lepage</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="En savoie">
            <div className="Div-vendue">
              <a href={Ensavoie}>
                <img
                  src={Ensavoie}
                  alt="En savoie"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>En savoie</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Coupe-De-Raisin">
            <div className="Div-vendue">
              <a href={CoupeDeRaisin}>
                <img
                  src={CoupeDeRaisin}
                  alt="Coupe de raisin"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Coupe de raisin</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Les-Trois-Gres">
            <div className="Div-vendue">
              <a href={LesTroisGres}>
                <img
                  src={LesTroisGres}
                  alt="Les trois grès"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Les trois grès</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Fruits-Dete">
            <div className="Div-vendue">
              <a href={FruitsDete}>
                <img
                  src={FruitsDete}
                  alt="Fruits d'été"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Fruits d'été</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Alcools">
            <div className="Div-vendue">
              <a href={Alcools}>
                <img
                  src={Alcools}
                  alt="Alcools"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Alcools</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Inspiration">
            <div className="Div-vendue">
              <a href={Inspiration}>
                <img
                  src={Inspiration}
                  alt="inspiration"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Inspiration</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Alcool-Et-Dentelle">
            <div className="Div-vendue">
              <a href={AlcoolEtDentelle}>
                <img
                  src={AlcoolEtDentelle}
                  alt="Alcool et dentelle"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Alcool et dentelle</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="PommesEtCroissants">
            <div className="Div-vendue">
              <a href={PommeEtCroissants}>
                <img
                  src={PommeEtCroissants}
                  alt="Pommes et croissants"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Pommes et croissants</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="EncrierEtTimbale">
            <div className="Div-vendue">
              <a href={EncrierEtTimbale}>
                <img
                  src={EncrierEtTimbale}
                  alt="Encrier et timbale"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Encrier et timbale</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="FleursEtFramboises">
            <div className="Div-vendue">
              <a href={FleurEtFramboises}>
                <img
                  src={FleurEtFramboises}
                  alt="Fleur et framboises"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Fleurs et framboises</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="FleurDeternite">
            <div className="Div-vendue">
              <a href={FleurDeternite}>
                <img
                  src={FleurDeternite}
                  alt="Fleur d'éternité"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Fleur d'éternité</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Androsaces-Avec-Opinel">
            <div className="Div-vendue">
              <a href={AndrosacesAvecOpinel}>
                <img
                  src={AndrosacesAvecOpinel}
                  alt="Androsaces avec opinel"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Androsaces avec opinel</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Pause-Casse-Croute">
            <div className="Div-vendue">
              <a href={PauseCasseCroute}>
                <img
                  src={PauseCasseCroute}
                  alt="Pause Casse-Croute"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Pause casse croute</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Pause-Lecture">
            <div className="Div-vendue">
              <a href={PauseLecture}>
                <img
                  src={PauseLecture}
                  alt="Pause lecture"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Pause lecture</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Fruits-Rouges">
            <div className="Div-vendue">
              <a href={FruitsRouges}>
                <img
                  src={FruitsRouges}
                  alt="Fruits rouges"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Fruits rouges</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="LesPlaisirsDefendus">
            <div className="Div-vendue">
              <a href={LesPlaisirsDefendus}>
                <img
                  src={LesPlaisirsDefendus}
                  alt="Les plaisirs défendus"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Les plaisirs défendus</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Sagesse-De-Lorient">
            <div className="Div-vendue">
              <a href={SagesseDeLorient}>
                <img
                  src={SagesseDeLorient}
                  alt="Sagesse de l'orient"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Sagesse de l'orient</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Mignonne-Allons-Voir-Si-La-Rose">
            <div className="Div-vendue">
              <a href={MignonneAllonsVoirSiLaRose}>
                <img
                  src={MignonneAllonsVoirSiLaRose}
                  alt="Mignonne allons voir si la rose ..."
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Mignonne allons voir si la rose...</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="CasseCrouteSavoyard">
            <div className="Div-vendue">
              <a href={CasseCrouteSavoyard}>
                <img
                  src={CasseCrouteSavoyard}
                  alt="Casse-Croûte Savoyard"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Casse-croûte savoyard</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="CerisesEtFraise">
            <div className="Div-vendue">
              <a href={CerisesEtFraise}>
                <img
                  src={CerisesEtFraise}
                  alt="Cerise et fraise"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Cerises et fraise</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Tomme-Et-Carlines">
            <div className="Div-vendue">
              <a href={TommeEtCarlines}>
                <img
                  src={TommeEtCarlines}
                  alt="Tomme et Carlines"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Tomme et Carlines</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="UnGrandBol">
            <div className="Div-vendue">
              <a href={UnGrandBol}>
                <img
                  src={UnGrandBol}
                  alt="Un grand bol"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Un grand bol</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="PainEtOeufs">
            <div className="Div-vendue">
              <a href={PainEtOeufs}>
                <img
                  src={PainEtOeufs}
                  alt="Pain et oeufs"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Pain et oeufs</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="EncrierI">
            <div className="Div-vendue">
              <a href={EncrierI}>
                <img
                  src={EncrierI}
                  alt="Encrier I"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Encrier I</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="UnPichetDore">
            <div className="Div-vendue">
              <a href={UnPichetDore}>
                <img
                  src={UnPichetDore}
                  alt="Un pichet doré"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Un pichet dorée</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Aladin">
            <div className="Div-vendue">
              <a href={Aladin}>
                <img src={Aladin} alt="Aladin" title="Cliquez pour agrandir" />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Aladin</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="EncrierII">
            <div className="Div-vendue">
              <a href={EncrierII}>
                <img
                  src={EncrierII}
                  alt="Encrier II"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Encrier II</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="PipeEtunPichetDore">
            <div className="Div-vendue">
              <a href={PipeEtPichetDoree}>
                <img
                  src={PipeEtPichetDoree}
                  alt="Pipe et pichet doré"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Pipe et un pichet doré</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Pause-Casse-Croute-II">
            <div className="Div-vendue">
              <a href={PauseCasseCrouteII}>
                <img
                  src={PauseCasseCrouteII}
                  alt="Pause casse-croûte II"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Pause casse-croûte II </h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="UnPetitCroissant">
            <div className="Div-vendue">
              <a href={UnPetitCroissant}>
                <img
                  src={UnPetitCroissant}
                  alt="Un P'tit croissant"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Un P'tit croissant</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Un-Ptit-Noir">
            <div className="Div-vendue">
              <a href={UnPetitNoir}>
                <img
                  src={UnPetitNoir}
                  alt="Un P'tit noir"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Un P'tit Noir</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="CognacEtDentelle">
            <div className="Div-vendue">
              <a href={CognacEtDentelle}>
                <img
                  src={CognacEtDentelle}
                  alt="Cognac et dentelle"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Cognac et dentelle</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="PommeEtChocolat">
            <div className="Div-vendue">
              <a href={PommeEtChocolat}>
                <img
                  src={PommeEtChocolat}
                  alt="Pomme et chocolat"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Pomme et chocolat</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="FruitsRougesEtConfiture">
            <div className="Div-vendue">
              <a href={FruitsRougesEtConfiture}>
                <img
                  src={FruitsRougesEtConfiture}
                  alt="Fruits rouges et confiture"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Fruits rouges et confiture</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="Bonjour">
            <div className="Div-vendue">
              <a href={Bonjour}>
                <img
                  src={Bonjour}
                  alt="Bonjour"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Bonjour</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="LivresEtRose">
            <div className="Div-vendue">
              <a href={LivresEtRose}>
                <img
                  src={LivresEtRose}
                  alt="Livres et rose"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Livres et rose</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="CasseCrouteEnMontagne">
            <div className="Div-vendue">
              <a href={CasseCrouteEnMontagne}>
                <img
                  src={CasseCrouteEnMontagne}
                  alt="Casse-Croûte en montagne"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Casse-croûte en montagne</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="LeTempsDeslumieres">
            <div className="Div-vendue">
              <a href={CadreLeTempsDesLumieres}>
                <img
                  src={CadreLeTempsDesLumieres}
                  alt="Le temps des lumières"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Le temps des lumières</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="LitTerrature">
            <div className="Div-vendue">
              <a href={Litterature}>
                <img
                  src={Litterature}
                  alt="Littérature"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Littérature</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
          <figure id="ConfitureEtfruits">
            <div className="Div-vendue">
              <a href={ConfitureEtFruits}>
                <img
                  src={ConfitureEtFruits}
                  alt="Confiture et fruits"
                  title="Cliquez pour agrandir"
                />
              </a>
              <span className="Mot-Vendue-Image">Vendu</span>
            </div>
            <figcaption>
              <h4>Confiture et fruits</h4>
              <span className="Dimension-Coeur Compteur ">
                <span className="Coeur-Vide-Menu">
                  <i className="far fa-heart"></i>
                </span>
                <span className="Coeur-Plein-Menu">
                  <i className="fas fa-heart"></i>
                </span>
              </span>
            </figcaption>
          </figure>
        </div>
      </section>
    </main>
  );
}
export default Vendue;
